import axios from "axios";
import { setKeymetrics } from "../../Redux/Action";

const token =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6InMiLCJuYmYiOjE3MTQzODg5NTIsImV4cCI6MTcxNDQ3NTM1MiwiaWF0IjoxNzE0Mzg4OTUyfQ.KgeibbxuX-bGdwTgk2xqC80vuiL4QZjsctR9-l6gTQg";
const tokenforIntraday =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6InMiLCJuYmYiOjE3MTQzODg5NTIsImV4cCI6MTcxNDQ3NTM1MiwiaWF0IjoxNzE0Mzg4OTUyfQ.KgeibbxuX-bGdwTgk2xqC80vuiL4QZjsctR9-l6gTQg";

export const fetchIndicatorData = async (
  selecttimeFrame,
  selectedExchange,
  dispatch,
  setJsonData,
  isLoading
) => {
  try {
    dispatch({ type: "IS_LOADING", payload: true });
    let timeframeToken, IndicatorApi;
    if (
      selecttimeFrame === "OneMinute" ||
      selecttimeFrame === "FiveMinute" ||
      selecttimeFrame === "FifteenMinute" ||
      selecttimeFrame === "ThirtyMinute" ||
      selecttimeFrame === "OneHour"
    ) {
      timeframeToken = tokenforIntraday;
      IndicatorApi = `https://idart.ftconline.in/api/intradayanalytics/BulkData/Technicals/${selectedExchange}/${selectedExchange}CASH/${selecttimeFrame}`;
    } else {
      timeframeToken = token;
      IndicatorApi = `https://idart.ftconline.in/api/eodanalytics/BulkData/Technicals/${selectedExchange}/${selectedExchange}CASH/${selecttimeFrame}`;
    }
    const response = await axios.get(IndicatorApi, {
      headers: { Authorization: `Bearer ${timeframeToken}` },
    });
    dispatch(setJsonData(response.data));
    dispatch({ type: "IS_LOADING", payload: false });
  } catch (error) {
    console.error("Error fetching indicator data:", error);
  } finally {
    dispatch({ type: "IS_LOADING", payload: false });
  }
};

export const fetchVolData = async (dispatch, setJsonVol) => {
  // debugger;
  try {
    dispatch({ type: "IS_LOADING", payload: true });

    let url;
    url = `https://idart.ftconline.in/api/eodanalytics/BulkData/VolumeAnalysis`;
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    dispatch(setJsonVol(response.data));
    dispatch({ type: "IS_LOADING", payload: false });
  } catch (error) {
    console.error("Error fetching volume data:", error);
  } finally {
    dispatch({ type: "IS_LOADING", payload: false });
  }
};

export const fetchReturnData = async (
  selectedExchange,
  dispatch,
  setJsonReturn
) => {
  try {
    dispatch({ type: "IS_LOADING", payload: true });

    let IndicatorApi;
    IndicatorApi = `https://idart.ftconline.in/api/eodanalytics/BulkData/Returns/${selectedExchange}`;
    const response = await axios.get(IndicatorApi, {
      headers: { Authorization: `Bearer ${token}` },
    });
    dispatch(setJsonReturn(response.data));
    dispatch({ type: "IS_LOADING", payload: false });
  } catch (error) {
    console.error("Error fetching Return data:", error);
  } finally {
    dispatch({ type: "IS_LOADING", payload: false });
  }
};

export const fetchRSLData = async (
  selectedExchange,
  selecttimeFrame,
  selectopt,
  dispatch,
  setJsonRsl
) => {
  // debugger;
  try {
    dispatch({ type: "IS_LOADING", payload: true });

    let IndicatorApi, rslopt;
    if (selectopt === "RS_LEVEL_CLASSIC") {
      rslopt = "classic";
    } else {
      rslopt = "fibonacci";
    }
    IndicatorApi = `https://idart.ftconline.in/api/eodanalytics/BulkData/PivotPoints/${selectedExchange}/${selecttimeFrame}/${rslopt}`;
    const response = await axios.get(IndicatorApi, {
      headers: { Authorization: `Bearer ${token}` },
    });
    dispatch(setJsonRsl(response.data));
    dispatch({ type: "IS_LOADING", payload: false });
  } catch (error) {
    console.error("Error fetching Return data:", error);
  } finally {
    dispatch({ type: "IS_LOADING", payload: false });
  }
};
export const FetchKeyMetrics = async (dispatch, selectedExchange) => {
  let url = `https://www.dartstechbku2.com/api/eodanalytics/keymetrics/${selectedExchange}`;
  let token =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImFkbWluIiwibmJmIjoxNzM4NTc4Nzc0LCJleHAiOjE3Mzg2NjUxNzQsImlhdCI6MTczODU3ODc3NH0.Mx5D4JY6-cCiN-zZCPWPQg2aapZNqpfbHmxVxkKwB1M";

  try {
    dispatch({ type: "IS_LOADING", payload: true });
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    // const responseData = await response.json();
    dispatch(setKeymetrics(response.data));
  } catch (err) {
    console.error(err);
  } finally {
    dispatch({ type: "IS_LOADING", payload: false });
  }
};
